import { client } from '@api/client';

import { IAssetRentRequestDocument } from '@interfaces/rent/assetRent';
import {
	ICreateAssetRentRequestUploadUrlDTO,
	ICreateAssetRequestDocumentDTO,
	IDeleteAssetRequestDocumentDTO,
	IGetAssetRequestDocumentsDTO,
	IUpdateAssetRequestDocumentDTO,
} from '@interfaces/rent/dto/assetRentDocumentsDTO';

import { URL } from './urls';

const { assetsRentRequests } = URL;

export const createUploadUrlForRentRequestsDocument = ({
	fileName,
	requestId,
}: ICreateAssetRentRequestUploadUrlDTO): Promise<void> => {
	return client.post(`${assetsRentRequests}/${requestId}/documents/create-upload-url`, { fileName });
};

export const createAssetsRentRequestsDocument = ({
	requestId,
	description,
	fileId,
}: ICreateAssetRequestDocumentDTO): Promise<void> => {
	return client.post(`${assetsRentRequests}/${requestId}/documents`, { description, fileId });
};

export const updateAssetsRentRequestsDocument = ({
	documentId,
	requestId,
	description,
}: IUpdateAssetRequestDocumentDTO): Promise<void> => {
	return client.put(`${assetsRentRequests}/${requestId}/documents/${documentId}`, { description });
};

export const deleteAssetsRentRequestsDocument = ({
	documentId,
	requestId,
}: IDeleteAssetRequestDocumentDTO): Promise<void> => {
	return client.delete(`${assetsRentRequests}/${requestId}/documents/${documentId}`);
};

export const getAssetsRentRequestsDocuments = ({
	isAo,
	requestId,
}: IGetAssetRequestDocumentsDTO): Promise<IAssetRentRequestDocument[]> => {
	return client.get(`${assetsRentRequests}/${requestId}/documents/${isAo ? 'as-ao' : 'as-mno'}`);
};

